import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['field', 'validationSummary', 'submitButton']
  initialize() {}
  fieldValidated() {
    this.validationSummaryTarget.innerHTML = `<li>${this.fieldTargets
      .map((elem) => {
        return elem.dataset.validationResult
      })
      .filter((result) => result != '')
      .join('</li><li>')}</li>`

    const okFields = this.fieldTargets.filter((elem) => !elem.controller.fieldNotOk)
    this.submitButtonTargets.map((elem) => {
      elem.disabled = !(okFields.length === this.fieldTargets.length)
    })
  }
  submitButtonTargetConnected(submitButton) {
    submitButton.disabled = true
  }
}
